export default __webpack_public_path__ + "static/HTH-DESKTOP-cf14d2c6efee89e44aafcdb7a352b9ca.jpg";